import { Container, Row, Col } from 'react-bootstrap'

function VflConfirmation() {

return (
<>
	<div className="vfl__Confirmation pt-5">
		<Container>
			<Row>
				<Col lg={5} md={12} sm={12} className="text-center px-5">
				<h2><strong>VITALITY FOR LIFE</strong></h2>
				<h4 className="pb-5"><strong>Monthly Newsletter</strong></h4>
                <h3>Thanks for subscribing!</h3>
				<p className="pt-5 pb-2">I look forward to keeping you updated and staying connected. <br />
                Here's to your amazing health! In the meantime, you can also connect with me here:</p>
				<p>In the meantime, you can also connect with me here:</p>
				</Col>
				<Col lg={7} md={12} sm={12}>
				<div className="vfl__Confirmation--img pt-5">
					<img className="img-fluid" src="../images/vfl/img-happy-people.png" alt="" />
				</div>
				</Col>
			</Row>
		</Container>
	</div>
	<style jsx>{`
		.vfl__Confirmation{
			background: #efefef url(../images/vfl/img-hero-bg-confirmation.jpg) top right;
            padding-top: 100px;
        }
        img{
            max-width: 150%;
        }
        h3{
            margin-bottom: -30px;
        }
        p{
            font-size: 0.9rem;
        }
		@media(max-width: 1560px){
            img{
                max-width: 100%;
            }
		}
		`}
	</style>
</>
);
}
export default VflConfirmation;